import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { MenuItem, MenuService } from '@services/menu/menu.service';
import Keycloak from 'keycloak-js';
import { AuthorizationService } from '@services/authorization/authorization.service';
import { ContactsService } from '@services/contacts/contacts.service';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, TranslateModule, TooltipModule]
})
export class HeaderComponent implements OnInit {
    protected readonly menu = inject(MenuService);
    protected readonly contactsService = inject(ContactsService);
    protected readonly cdRef = inject(ChangeDetectorRef);
    navCollapsed = false;
    menuItems: MenuItem[] = [];
    chevron = 'fa-chevron-down';
    username!: string;
    department!: string;
    isNavSearchVisible!: boolean;
    inAdministration = false;

    @ViewChild('navBar', { static: true }) navBar!: ElementRef;

    protected readonly keycloak = inject(Keycloak);
    protected readonly authorizationService = inject(AuthorizationService);

    ngOnInit() {
        this.isNavSearchVisible = false;

        this.keycloak.loadUserProfile().then((keycloakProfile) => {
            this.username = keycloakProfile.firstName + ' ' + keycloakProfile.lastName;
            if (keycloakProfile.email) {
                this.contactsService.findByEmail(keycloakProfile.email);
            }
            const roles = this.authorizationService.roles.filter(role => role !== 'view-profile');
            this.menu.getMenu(roles).then(value => {
                this.menuItems = value;
                this.cdRef.detectChanges();
            });
        });

        this.setCollapse(false);
    }

    toggleSidebar() {
        this.setCollapse(!this.navCollapsed);
    }

    setCollapse(collapse: boolean) {
        this.navCollapsed = collapse;
    }

    logout() {
        this.keycloak.logout();
    }
}
